export default {
  path: "/SectionContent/Diagram",
  name: "Diagram",
  htmlContent: "diagrams.html",
  headings: [{ id: "n94Diagram", text: "94. Diagram ", type: "field" }],
};
